import { language } from 'shared/utils';

export const AMENITIES_ORDER_STATUS_UNCONFIRMED = 'PENDING';
export const AMENITIES_ORDER_STATUS_WAITING_CANCEL = 'WAITING_FOR_CANCELLED';
export const AMENITIES_ORDER_STATUS_WAITING_FINISH = 'WAITING_FOR_COMPLETED';
export const AMENITIES_ORDER_STATUS_CONFIRMED = 'APPROVED';
export const AMENITIES_ORDER_STATUS_FINISHED = 'COMPLETED';
export const AMENITIES_ORDER_STATUS_CANCELED = 'CANCELLED';
export const AMENITIES_ORDER_STATUS_ALL = 'ALL';

export const AMENITIES_ORDER_STATUS_ARRAY = [
  {
    key: AMENITIES_ORDER_STATUS_UNCONFIRMED,
    label: language.unconfirmed,
  },
  {
    key: AMENITIES_ORDER_STATUS_WAITING_CANCEL,
    label: language.waiting_cancel,
  },
  {
    key: AMENITIES_ORDER_STATUS_WAITING_FINISH,
    label: language.waiting_finish,
  },
  {
    key: AMENITIES_ORDER_STATUS_CONFIRMED,
    label: language.confirmed,
  },
  {
    key: AMENITIES_ORDER_STATUS_FINISHED,
    label: language.finished,
  },
  {
    key: AMENITIES_ORDER_STATUS_CANCELED,
    label: language.canceled,
  },
  {
    key: AMENITIES_ORDER_STATUS_ALL,
    label: language.all,
  },
];

export const AMENITIES_ORDER_STATUS_MAPPING = {
  [AMENITIES_ORDER_STATUS_UNCONFIRMED]: language.unconfirmed,
  [AMENITIES_ORDER_STATUS_WAITING_CANCEL]: language.waiting_cancel,
  [AMENITIES_ORDER_STATUS_WAITING_FINISH]: language.waiting_finish,
  [AMENITIES_ORDER_STATUS_CONFIRMED]: language.confirmed,
  [AMENITIES_ORDER_STATUS_FINISHED]: language.finished,
  [AMENITIES_ORDER_STATUS_CANCELED]: language.canceled,
  [AMENITIES_ORDER_STATUS_ALL]: language.all,
};

export const AMENITIES_ORDER_ACCEPT = 'ACCEPT';
export const AMENITIES_ORDER_REJECT = 'REJECT';

export const AMENITIES_ORDER_ACTIONS = [
  {
    key: AMENITIES_ORDER_ACCEPT,
    label: language.accept,
    icon: 'check',
  },
  {
    key: AMENITIES_ORDER_REJECT,
    label: language.reject,
    icon: 'times',
  },
];

export const AMENITIES_BILL_SURCHARGE = 'UTILITY_SURCHARGE';
export const AMENITIES_BILL_UTILITY = 'UTILITY';
